import { LoadingButton } from "@mui/lab";
import { styled, ButtonProps, SxProps, Theme } from "@mui/material";

interface Props extends ButtonProps {
  text: string | React.ReactNode;
  sx?: SxProps<Theme>;
  isLoading?: boolean;
}

const PrimaryButton = ({ sx, text, isLoading, ...props }: Props) => {
  const PrimaryButtonStyles = styled(LoadingButton)(({ theme }) => ({
    color: theme.palette.primaryButton.text,
    backgroundColor: theme.palette.primaryButton.background,
    fontFamily: "Inter",
    fontSize: "16px",
    fontStyle: "normal",
    fontWeight: "700",
    lineHeight: "22px",
    borderRadius: "32px",
    "&:hover": {
      backgroundColor: theme.palette.primaryButton.background,
    },
    "&:disabled": {
      opacity: 0.6,
      cursor: "not-allowed",
      pointerEvents: "all !important",
      color: isLoading ? undefined : theme.palette.primaryButton.text,
    },
    padding: "12px 24px 12px 24px",
    textTransform: "none",
  }));

  return (
    <PrimaryButtonStyles {...props} disableRipple sx={sx} loading={isLoading}>
      {text}
    </PrimaryButtonStyles>
  );
};

export default PrimaryButton;
